import {UserInMap, Map} from '@q9elements/ui-kit/common';

export interface MapUsers {
  title: string;
  role: string | MapRole;
  totalCount: number;
  users: UserInMap[];
  type: string;
}

export enum MapUserAction {
  ChangeRole = 'change-role',
  UpdatePermission = 'update-permission',
  RemoveMap = 'remove-map',
  RemoveUser = 'remove-user'
}

export interface MapUserEvent {
  data: UserInMap;
  action?: MapUserAction;
  user?: UserInMap;
}

export enum MapRole {
  VIEW = 'view',
  EDIT = 'edit',
  MANAGE = 'manage'
}

export interface MapUserCallbackEvent {
  data: {user?: {id: string}; role?: MapRole} | Map;
  action?: MapUserAction;
}

export enum MapUserPermission {
  CanCopy = 'canCopy',
  CanGrantAccess = 'canGrantAccess',
  CanAddNotes = 'canAddNotes'
}
